import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../hooks";
import "./Login.scss";

export function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  function handleChange(event) {
    const { name, value } = event.target;

    setFormData((currentData) => ({
      ...currentData,
      [name]: value,
    }));

    if (error) {
      setError("");
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();

    if (!formData.email.trim() || !formData.password) {
      setError("Ingresa tu correo electrónico y contraseña.");
      return;
    }

    try {
      setIsLoading(true);
      setError("");

      const result = await login(formData);

      // El acceso al panel ya no depende solo del campo legado
      // "role" (ADMIN/CUSTOMER) -- también entra cualquier usuario
      // con al menos un rol asignado desde el módulo Roles (Inventario,
      // etc.), que es como se maneja el acceso en el resto del panel
      // (ver usePermissions). Antes esta pantalla se quedó con la
      // regla vieja y bloqueaba a esos usuarios justo en el login.
      const hasAssignedRole =
        Array.isArray(result.user?.roles) && result.user.roles.length > 0;
      const hasAdminAccess = result.user?.role === "ADMIN" || hasAssignedRole;

      if (!hasAdminAccess) {
        setError("Tu usuario no tiene permisos para acceder al panel.");

        return;
      }

      navigate("/admin", {
        replace: true,
      });
    } catch (errorResponse) {
      setError(
        errorResponse?.msg ||
          "No fue posible iniciar sesión. Verifica tus credenciales."
      );
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-page__brand">
        <div className="login-page__brand-content">
          <span className="login-page__eyebrow">ADMIN PANEL</span>

          <h1>LUX & GLAM</h1>

          <p>
            Gestiona productos, inventario, pedidos y la experiencia de tu
            tienda desde un solo lugar.
          </p>
        </div>
      </section>

      <section className="login-page__form-section">
        <div className="login-page__form-container">
          <header className="login-page__header">
            <span className="login-page__eyebrow login-page__eyebrow--mobile">
              ADMIN PANEL
            </span>

            <h2>Bienvenido de nuevo</h2>

            <p>Ingresa tus credenciales para continuar.</p>
          </header>

          <form className="login-page__form" onSubmit={handleSubmit}>
            {error && (
              <div className="login-page__error" role="alert">
                {error}
              </div>
            )}

            <label htmlFor="email">Correo electrónico</label>

            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="nombre@correo.com"
              autoComplete="email"
              disabled={isLoading}
              required
            />

            <label htmlFor="password">Contraseña</label>

            <div className="login-page__password">
              <input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleChange}
                placeholder="••••••••"
                autoComplete="current-password"
                disabled={isLoading}
                required
              />

              <button
                type="button"
                className="login-page__toggle-password"
                onClick={() => setShowPassword((current) => !current)}
                disabled={isLoading}
                aria-label={
                  showPassword ? "Ocultar contraseña" : "Mostrar contraseña"
                }
              >
                {showPassword ? "Ocultar" : "Mostrar"}
              </button>
            </div>

            <button
              type="submit"
              className="login-page__submit"
              disabled={isLoading}
            >
              {isLoading ? "Iniciando sesión..." : "Iniciar sesión"}
            </button>
          </form>

          <p className="login-page__help">
            ¿Problemas para acceder? Contacta al administrador del sistema.
          </p>
        </div>
      </section>
    </main>
  );
}